import { render, staticRenderFns } from "./file_tree_browser_toggle.vue?vue&type=template&id=522a1b04&scoped=true"
import script from "./file_tree_browser_toggle.vue?vue&type=script&lang=js"
export * from "./file_tree_browser_toggle.vue?vue&type=script&lang=js"
import style0 from "./file_tree_browser_toggle.vue?vue&type=style&index=0&id=522a1b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a1b04",
  null
  
)

export default component.exports